import Plus from "app/smartphone/[slug]/[reference]/SuppliedAccessoriesSection/plus.svg";
import { StrapiImage, StrapiImageData } from "ui/StrapiImage";
import { isWidePicture } from "ui/StrapiImage/picture-shape";

type AccessoryCardProps = { name?: string; image?: StrapiImageData };

/**
 * A square frame shrinks a panoramic pack picture to a thin band, because the
 * picture keeps its ratio inside the frame. So a wide picture takes a wide frame,
 * and it also takes a larger file: the thumbnail of a pack is 245 px wide, and
 * the frame is 320 px at `sm`.
 */
export const AccessoryCard = ({ image, name }: AccessoryCardProps) => {
  const isWide = isWidePicture(image);

  return (
    <>
      <div className="flex flex-col gap-2 items-center">
        <p className="font-semibold text-center lg:hidden">{name}</p>
        <StrapiImage
          size={isWide ? "large" : "thumbnail"}
          image={image}
          className={
            isWide ? "w-52 h-24 sm:w-80 sm:h-36" : "min-w-[6rem] min-h-[6rem]"
          }
          sizes={
            isWide
              ? "(max-width: 640px) 13rem, 20rem"
              : "(max-width: 1024px) 50vw, 33vw"
          }
        />
        <p className="hidden font-semibold lg:block">{name}</p>
      </div>
      <Plus className="hidden lg:block lg:last:hidden" />
    </>
  );
};
